import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BasePage } from 'src/app/lib/base-page';
import { UpdateProfileBody, UserModel } from 'src/app/models/login';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-add-bio',
  templateUrl: './add-bio.page.html',
  styleUrls: ['./add-bio.page.scss'],
})
export class AddBioPage extends BasePage implements OnInit {
  bio: string;

  date: string;
  phoneNumb: string;
  name: string;
  surname: string;
  gender: number;
  originalUser: UserModel;

  constructor(private location: Location, private loginService: LoginService) {
    super();
    this.loginService.profile().subscribe((res) => {
      this.phoneNumb = res.data.phone_number;
      this.date = res.data.birth_date;
      this.gender = res.data.gender;
      this.name = res.data.first_name;
      this.surname = res.data.last_name;
      this.bio = res.data.bio;
      this.originalUser = res.data;
    });
  }

  ngOnInit() {}

  navigate() {
    this.location.back();
  }

  updateBio() {
    //TODO: conect with the api
    //this.location.back()
    const newUser: UpdateProfileBody = {
      birth_date: this.date,
      first_name: this.name,
      last_name: this.surname,
      gender: this.gender,
      phone_number: this.phoneNumb,
      bio: this.bio,
    };
    this.loginService.updateProfile(newUser).subscribe((res) => {
      // TODO: display alert
      this.location.back();
    });
  }
}
